import { combineReducers } from 'redux';

import locationReducer from './locationReducer'
import drawerReducer from './drawerReducer'

export default combineReducers({
    locationReducer,
    drawerReducer,
});